module.exports = __webpack_public_path__ + "img/home_class_revise_normal.31a879ae.svg";